import AgoraRTC, { SDK_MODE } from 'agora-rtc-react'

type AgoraConfig = {
  uid: number
  appId: string
  channelName: string
  rtcToken: string | null
  serverUrl: string
  proxyUrl: string
  tokenExpiryTime: number
  token: string
  encryptionMode: string
  salt: ''
  encryptionKey: string
  destUID: number
  destChannelName: string
  destChannelToken: string
  secondChannel: string
  secondChannelToken: string
  secondChannelUID: number
  selectedProduct: SDK_MODE
}

const agoraConfig: AgoraConfig = {
  uid: 0,
  appId: '',
  channelName: 'test',
  rtcToken: '',
  serverUrl: '',
  proxyUrl: 'http://localhost:8080/',
  tokenExpiryTime: 600,
  token: '',
  encryptionMode: 'aes-128-gcm2',
  salt: '',
  encryptionKey: '',
  destChannelName: '',
  destChannelToken: '',
  destUID: 2,
  secondChannel: '',
  secondChannelToken: '',
  secondChannelUID: 2,
  selectedProduct: 'rtc'
}

export const agoraClient = AgoraRTC.createClient({ codec: 'vp8', mode: agoraConfig.selectedProduct })
